import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { trigger, state, style, transition, useAnimation } from '@angular/animations';
import { bounceInRight, bounceOutRight } from 'ng-animate';
import { MessageService } from 'src/app/service/message.service';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    animations: [
        trigger('message', [
          state("show", style({})),
          state("hide", style({})),
    
          transition('hide => show', [
            useAnimation(bounceInRight)
          ]),
          transition('show => hide', [
            useAnimation(bounceOutRight)
          ])
        ])
      ]
})
export class MessageComponent implements OnInit{

    @Input() msg = '';

    @ViewChild('message') message: ElementRef<HTMLElement>;
    
    constructor(private messageService: MessageService) {}

    ngOnInit() {}

    setVisible() {
      if (this.stateMessage === 'show') {
        this.message.nativeElement.classList.remove('hidden');
      }    
    }
  
    setHidden() {
      if (this.stateMessage === 'hide') {
        this.message.nativeElement.classList.add('hidden');
      }
    }

    get stateMessage() {
        return this.messageService.getShowMessage() ? "show" : "hide";
    }
    
    closeMessage() {
        setTimeout(() => {
            this.messageService.setShowMessage(false);
        }, 2000);

        this.setHidden();
    }
}